function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import URI from 'urijs';
import { format } from 'date-fns';
import Backbone from '@polleverywhere/backbone';
import env from '../env';
import SubModel from './mixins/_sub_model';
import Instance from './mixins/_instance';
import LiveUpdates from './mixins/_live';
import Base from './base';
import Polls from './polls';
import Results from './results';
import FlashOptions from './flash_options';
import { cleanString } from '../util';
import subscribe from '@polleverywhere/firehose_client';
var GLOBAL_ATTRS = ['anonymous', 'show_branding'];

function configureFlashOptions() {
  this._flashOptions.set({
    showInstructions: false,
    showTitle: true,
    font: 'source-sans-pro',
    header_bottom_background_color: 'rgba(255,255,255,1)',
    header_top_background_color: 'rgba(255,255,255,1)',
    header_title_color: 0,
    title_scale: 0.09615384615384615,
    headerLogoPlacement: 'center'
  });

  this._flashOptions.fetch = function () {
    return Promise.resolve();
  };

  this._flashOptions.save = function () {};

  return this._flashOptions;
}

var bulkSavePollData = function bulkSavePollData(polls) {
  var data = {
    polls: polls
  };
  return Backbone.ajax({
    method: 'POST',
    url: '/api/polls',
    data: JSON.stringify(data),
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json'
  });
};
/**
 * Normalizes the specified dataset and mutates it.
 * @param {Object} attrs
 * @return {Object} Mutated attrs
 */


function normalizeAttrs(attrs) {
  if (attrs === void 0) {
    attrs = {};
  } // fix inconsistent collection data from backend


  attrs.polls = attrs.polls || [];
  attrs.polls = attrs.polls.map(function (poll) {
    poll.presenter = Object.assign({}, attrs.presenter, poll.presenter);
    poll.group_id = null;
    poll.survey_id = attrs.id;
    poll.competition_id = null;
    return poll;
  });
  return Object.assign(attrs, getGlobalAttrResultsFromPolls(attrs.polls));
}

function getGlobalAttrResultsFromPolls(polls) {
  return GLOBAL_ATTRS.reduce(function (attrs, attr) {
    attrs[attr] = polls.some(function (poll) {
      return poll[attr];
    });
    return attrs;
  }, _.object(GLOBAL_ATTRS, []));
}

function getSurveyMetricData(model) {
  var key = model.get('presenter_key');
  var firehoseChannel = subscribe("/instances/surveys/" + key + "/metrics.json", {
    host: env.get('firehose_url').toString(),
    ssl: env.get('firehose_ssl')
  });
  firehoseChannel.on('message', processSurveyMetricData.bind(model.metrics));
  return firehoseChannel;
}

function processSurveyMetricData(json) {
  var completedThreshold = 1;
  var length = json.polls_answered != null ? json.polls_answered.length : undefined;
  var bars = json.polls_answered.map(function (a, i) {
    if (a.completed >= completedThreshold) {
      a.sortOrder = i;
    } else {
      a.sortOrder = i + length;
    }

    a.id = i + a.name;
    return a;
  });
  var progress = json.completed ? json.completed / (json.started + json.completed) : 0;
  this.set({
    started: json.started,
    completed: json.completed,
    bars: bars,
    progress: progress
  });
}

function sendSurveyMetric(index) {
  var participantKey = this.get('participant_key');

  if (participantKey) {
    var uri = URI('/api/participant/surveys').segment(participantKey).segment('metrics');
    return Backbone.ajax({
      method: 'PUT',
      url: uri.toString(),
      data: {
        index: index
      }
    });
  } else {
    window.Rollbar && window.Rollbar.error('Cannot send survey metrics without participantKey', {
      model: this.attributes
    });
    return Backbone.$.Deferred().reject();
  }
}

var Survey = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Survey, _Base);

  function Survey() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Survey.prototype;
  /**
   * Returns a stubbed FlashOptions model, primarily for Viz that depends on
   * this being attached to the activity model.
   * @return {Backbone.Model.FlashOptions}
   */

  _proto.flashOptions = function flashOptions() {
    return this.flashOptionsStub;
  };

  _proto.initialize = function initialize(attrs, options) {
    var _this = this;

    if (attrs === void 0) {
      attrs = {};
    }

    if (options === void 0) {
      options = {};
    }

    this.include(LiveUpdates);
    this.include(SubModel);
    this.include(Instance);
    this.initSubModel('presenter');
    this.metrics = new Backbone.Model({
      completed: 0,
      started: 0,
      bars: [],
      progress: 0
    });
    this.polls = new Polls(null, {
      poll: this
    });
    this.polls.comparator = 'position';
    this.parse(attrs, options);
    this.on('change:polls', function () {
      /*
       * For backwards compatibility.
       * `#parse` currently converts the `poll` attribute into
       * a collection unless silent is passed in.
       */
      var pollArray;

      if (_this.get('polls') instanceof Backbone.Collection) {
        pollArray = _this.get('polls').toArray();
      } else {
        pollArray = _this.get('poll');
      }

      return _this.polls.set(pollArray);
    });
    /**
     * Holds reference to a stubbed FlashOptions model because Viz needs one.
     * @type {Backbone.Model.FlashOptions}
     */

    this.initSubModel('flash_options', {
      model: FlashOptions,
      prefix: '_'
    }).poll = this;
    this.flashOptionsStub = configureFlashOptions.call(this);
  }
  /**
   * Override cloning to ensure all its internal subpolls are also cloned.
   * @return {Survey}
   */
  ;

  _proto.clone = function clone() {
    var clone = _Base.prototype.clone.call(this);

    var pollsData = this.polls.map(function (poll) {
      return poll.attributes;
    });
    clone.polls.set(pollsData);
    clone.metrics.set(this.metrics.attributes);
    return clone;
  };

  _proto.url = function url() {
    return this.instance.url();
  };

  _proto.type = function type() {
    return 'survey';
  }
  /**
   * Convert this into the specified target type.
   * @param {string} targetType What to convert this into, e.g. `group`
   * @return {Promise}
   */
  ;

  _proto.convertTo = function convertTo(targetType) {
    var key = this.get('id') || this.get('permalink');
    var url = URI(this.urlRoot).segment(key.toString()).segment("convert_to_" + targetType).toString();
    return Backbone.ajax({
      url: url,
      method: 'post',
      dataType: 'json'
    });
  };

  _proto.enableAndClearAllPolls = function enableAndClearAllPolls() {
    var url = URI('/api').segment(this.showPath()).segment('enable_clear_polls');
    return Backbone.ajax({
      contentType: 'application/json; charset=UTF-8',
      dataType: 'json',
      url: url.toString(),
      type: 'POST'
    });
  } // TODO(deprecate): Unused. Replace with `clearResults()` method.
  ;

  _proto.clearPolls = function clearPolls(name) {
    if (name === void 0) {
      name = format(new Date(), 'MMMM d, yyyy \'at\' h:mm:ss a');
    }

    var url = URI('/api').segment(this.showPath()).segment('clear').toString();
    return Backbone.ajax({
      url: url,
      type: 'POST',
      data: {
        name: name
      }
    });
  }
  /*
   * @deprecated
   *
   */
  ;

  _proto.pollsAnswered = function pollsAnswered() {
    var total = 0;
    var object = this.pollsAnsweredCache || {};

    for (var p in object) {
      var votes = object[p];
      total += votes;
    }

    return total;
  }
  /*
   * @deprecated
   *
   */
  ;

  _proto.trackResponse = function trackResponse(response, val) {
    /*
     * We only want to track responses
     * that haven't been submitted to the server
     */
    if (!response.isNew()) {
      return;
    }

    if (this.pollsAnsweredCache == null) {
      this.pollsAnsweredCache = this.polls.reduce(function (hash, p) {
        hash[p.id] = 0;
        return hash;
      }, {});
    }

    this.pollsAnsweredCache[response.get('poll_id')] = val;
    return this.trigger('pollAnswered');
  };

  _proto.requiresRegistration = function requiresRegistration() {
    return this.polls.any(function (p) {
      return p.get('registered_participants_only');
    });
  }
  /*
   * Deprecated method
   *
   * We used to append 'survey' to name,
   * but have since removed this behavior
   * since our UI presentation is more obviously a survey
   */
  ;

  _proto.name = function name() {
    return this.get('title');
  }
  /*
   * Deprecated method
   *
   * Use `showUrl` to conform with Poll API
   * @deprecated
   */
  ;

  _proto.showPath = function showPath() {
    return this.showUrl();
  }
  /*
   * Url for poll renderer
   *
   */
  ;

  _proto.screenshotUrl = function screenshotUrl(opts) {
    if (opts === void 0) {
      opts = {};
    } // backwards compatible with screenshotUrl(true)


    if (opts === true) {
      opts = {
        attachment: true
      };
    }

    return URI(this.showUrl()).absoluteTo(env.get('poll_renderer_url')).query(opts).toString();
  }
  /*
   * Get the relative browser URL
   *
   */
  ;

  _proto.showUrl = function showUrl() {
    return URI('/surveys').segment(this.get('permalink')).toString();
  };

  _proto.editUrl = function editUrl() {
    return this.showPath() + '/edit';
  };

  _proto.duplicateUrl = function duplicateUrl() {
    /*
     * NOTE: Using urlRoot + id here. url() returns the urlRoot or with a
     * permalink if ID doesn't exist. This way we ensure that it's always using
     * ID for the copy endpoint.
     */
    return URI(this.urlRoot).segment(this.get('id').toString()).segment('duplicate').toString();
  }
  /**
   * Public shareable response link. Should support both cases when poll has
   * only the permalink or a participant_key.
   * @return {string}
   */
  ;

  _proto.webVotingUrl = function webVotingUrl() {
    return this.instance.webRespondUrl;
  }
  /*
   * API endpoint for activation
   *
   */
  ;

  _proto.onScreenUrl = function onScreenUrl() {
    return '/api/activation';
  };

  _proto.toJSON = function toJSON(options) {
    if (options == null) {
      options = {};
    }

    var obj = this.pick(this.modelProperties);
    obj.polls = this.polls.invoke('toJSON', {
      root: false
    }).filter(function (poll) {
      return !_.isEmpty(poll);
    });
    return obj;
  };

  _proto.parse = function parse(attrs, options) {
    if (attrs === void 0) {
      attrs = {};
    }

    if (options === void 0) {
      options = {};
    }

    if (this.instance) {
      // All instance data must be normalized to support legacy keys.
      attrs = this.instance.normalizeActivityData(attrs);
    }

    if (this.polls && attrs.polls) {
      attrs = normalizeAttrs(attrs);
      this.polls.set(attrs.polls, options); // Remove the polls key from model attrs to ensure the polls collection is
      // the single source of truth for subpoll data.

      delete attrs.polls;
    }

    return attrs;
  };

  _proto.liveChannel = function liveChannel() {
    return this.type() + "s/" + this.get('permalink') + "/firehose.json";
  }
  /**
   * Parse Firehose response into the model.
   * @param {object} data Firehose response data.
   * @return {object} Returns potentially mutated data.
   */
  ;

  _proto.processLiveResponse = function processLiveResponse(data) {
    if (data === void 0) {
      data = {};
    } // Always update the activity for every Firehose update.


    this.set(this.parse(data));
    return data;
  }
  /*
   * Make partial changes to survey.
   * @param {Object} attrs
   * Supported params are title, subtitle, custom_confirmation_message, full_page
   *
   * @example Usage
   * @model.update
   * title: "new survey title"
   * subtitle: "from Matt"
   */
  ;

  _proto.update = function update(attrs) {
    var opts = {
      patch: true
    };
    return this.save(attrs, opts);
  }
  /*
   * Make partial changes to survey polls.
   * Differs from `updateAllPolls` because you can
   * provide different attrs for each poll.
   * @param {Array} polls
   * `polls` is an array of objects.
   * Each object is required to have a permalink key. In addition to that
   * it may specify any valid poll attribute that it wants to modify.
   *
   * @example Usage
   * @model.updatePolls [
   * {permalink: "abc", title: "test"}
   * {permalink: "bcd", max_votes: 20}
   * ]
   */
  ;

  _proto.updatePolls = function updatePolls(polls) {
    var _this2 = this;

    polls.forEach(function (p) {
      var poll = _this2.polls.findWhere({
        permalink: p.permalink
      });

      poll && poll.set(p);
    });
    return bulkSavePollData(polls);
  }
  /*
   * update each survey poll with the same value
   * Usage:
   * @model.updateAllPolls
   *   registered_participants_only: true
   *   max_votes: 30
   */

  /*
   * Make partial changes to survey polls.
   * Differs from `updateAllPolls` because you can
   * attributes passed in are applied to ALL polls.
   * @param {Object} attrs
   * `attrs` is an object of poll attributes to apply to each survey poll.
   *
   * @example Usage
   * @model.updateAllPolls
   * registered_participants_only: true
   * max_votes: 30
   */
  ;

  _proto.updateAllPolls = function updateAllPolls(attrs) {
    var pollData = this.polls.map(function (p) {
      p.set(attrs);
      return _.extend({}, {
        permalink: p.get('permalink')
      }, attrs);
    });
    return bulkSavePollData(pollData);
  };

  _proto.activate = function activate() {
    var _this3 = this;

    var activation = Backbone.ajax({
      method: 'PUT',
      url: this.onScreenUrl(),
      data: {
        type: this.type(),
        uid: this.get('permalink')
      }
    });
    activation.done(function () {
      _this3.presenter.set({
        active: true
      });

      _this3.set({
        current: true
      });
    });
    return activation;
  };

  _proto.deactivate = function deactivate() {
    var _this4 = this;

    var deactivation = Backbone.ajax({
      method: 'DELETE',
      url: this.onScreenUrl()
    });
    deactivation.done(function () {
      _this4.presenter.set({
        active: false
      });

      _this4.set({
        current: false
      });
    });
    return deactivation;
  };

  _proto.lockAllPolls = function lockAllPolls() {
    return this.polls.invoke('stop');
  };

  _proto.unlockAllPolls = function unlockAllPolls() {
    return this.polls.invoke('start');
  };

  _proto.getMetrics = function getMetrics() {
    return getSurveyMetricData(this);
  };

  _proto.resetMetrics = function resetMetrics() {
    this.metrics.set({
      completed: 0,
      started: 0,
      bars: [],
      progress: 0
    });
  };

  _proto.start = function start() {
    return sendSurveyMetric.call(this, 0);
  };

  _proto.complete = function complete() {
    return sendSurveyMetric.call(this, this.polls.length);
  };

  _proto.progress = function progress(pollsAnswered) {
    if (pollsAnswered === void 0) {
      pollsAnswered = 0;
    }

    return sendSurveyMetric.call(this, pollsAnswered);
  };

  _proto.cleanTitle = function cleanTitle(opts) {
    if (opts == null) {
      opts = {};
    }

    opts = _.defaults(opts, {
      emoji: 'image'
    });
    return cleanString(this.get('title'), opts);
  };

  _proto.isActivated = function isActivated() {
    return this.get('current');
  };

  _proto.state = function state() {
    var pollStates = _.uniq(this.polls.map(function (p) {
      return p.get('state');
    }));

    if (pollStates.length === 1) {
      return pollStates[0];
    }
  };

  _proto.isMQA = function isMQA() {
    return true;
  };

  _proto.mqaType = function mqaType() {
    return 'survey';
  };

  _createClass(Survey, [{
    key: "urlRoot",
    get: function get() {
      return '/api/surveys';
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        full_page: false
      };
    }
  }, {
    key: "modelProperties",
    get: function get() {
      return ['id', 'permalink', 'owner_id', 'group_id', 'title', 'subtitle', 'full_page', 'display_state', 'custom_confirmation_message'];
    }
    /**
     * Collection of participant submitted results.
     * @return {Results}
     */

  }, {
    key: "results",
    get: function get() {
      if (!this._results) {
        this._results = new Results(null, {
          poll: this
        });
      }

      return this._results;
    }
  }]);

  return Survey;
}(Base);

export { Survey as default };